import React, { FC, useState } from "react";
import { Loader } from "components";
import { Box } from "@chakra-ui/react";
interface IIFrameComponent {
  srcLink: string;
  [key: string]: any; // Allow other props to pass through
}

const IFrameComponent: FC<IIFrameComponent> = ({ srcLink }) => {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <Box position="relative" width="100%" height="100vh">
      {isLoading && (
        <Box
          justifyContent="center"
          alignItems="center"
          display="flex"
          height="100vh"
        >
          <Loader />
        </Box>
      )}
      <iframe
        src={srcLink}
        onLoad={() => setIsLoading(false)}
        sandbox="allow-scripts allow-forms allow-same-origin allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-top-navigation-to-custom-protocols"
        height="100%"
        width="100%"
        allow="web-share"
      />
    </Box>
  );
};

export default IFrameComponent;
